import React, { useEffect, useState, useContext } from "react";
import {
  Container,
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import DataTable from "react-data-table-component";
import { motion } from "framer-motion";
import {
  createVessel,
  getVesselsByOwner,
  getVessel,
} from "../../../../api/VesselDetails/addVesselApi"; // Adjust path as needed
import { AuthContext } from "../../../ExtraPages/AuthProvider";
import "./VesselDetailsOffcanvas.css";
import VesselDetailsOffcanvas from "./VesselDetailsOffcanvas";
import { FaEye, FaEdit, FaUserPlus, FaCamera, FaQrcode } from "react-icons/fa"; // Import desired icons
import CrewMember from "./CrewMember";
import ImageCropModal1 from "./ImageCropModal1";
import ImageCropModal3 from "./ImageCropModal3";
import BoatGalleryModal from "./BoatGalleryModal";
import boat from "../../../../assets/images/stock_details/boat.png";
import boat1 from "../../../../assets/images/stock_details/boat_1.png";
import boat2 from "../../../../assets/images/stock_details/boat_2.png";
import boat3 from "../../../../assets/images/stock_details/boat_3.png";

const Vessels = () => {
  const [selectedVesselForCrew, setSelectedVesselForCrew] = useState(null);
  const [isCrewModalOpen, setIsCrewModalOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpen1, setModalOpen1] = useState(false);
  const [vessel, setVessel] = useState("");
  const [uploadedImageUrl, setUploadedImageUrl] = useState(null);
  const [key, setKey] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [fileNumber, setFileNumber] = useState(0);
  const [imageLarge, setImageLarge] = useState(null);
  const [imageSmall1, setImageSmall1] = useState(null);
  const [imageSmall2, setImageSmall2] = useState(null);
  const [imageSmall3, setImageSmall3] = useState(null);
  const [imageSmall4, setImageSmall4] = useState(null);

  const images = [
    imageLarge || boat, // Replace with actual path
    imageSmall1 || boat1,
    imageSmall2 || boat1,
    imageSmall3 || boat1,
    imageSmall4 || boat1,
  ];

  const setVesselModalOpen = (vessel1) => {
    setVessel(vessel1);
    setModalOpen(true);
  };
  const handleCrewAdded = async () => {
    try {
      const response = await getVesselsByOwner(userId);
      setAllVessels(response.data || []);
    } catch (error) {
      console.error("Error refreshing vessels:", error);
    }
  };
  const toggleCrewModal = (vessel) => {
    setSelectedVesselForCrew(vessel);
    setIsCrewModalOpen(!isCrewModalOpen);
  };

  const sampleVessels = [
    {
      _id: "vessel001",
      Name: "Ocean Star",
      Flag: "USA",
      IMO: "IMO1234567",
      IMULA_Number: "IMULA001",
      Call_Sign: "WXYZ123",
      AIS_transponder_Class: "Class A",
      General_vessel_Type: "Fishing",
      Detailed_vessel_Type: "Trawler",
      Categories: "Commercial",
      Service_Status: "Active",
      Port_of_registry: "Boston",
      Year_Built: 2015,
      License_Category: "Category A",
      National: "USA",
      Registered_Date: "2015-03-10T00:00:00.000Z",
      Breadth: 8.5,
      Height: 4.2,
      Fuel_Type: "Diesel",
      Engine_Type: "Inboard",
      Fuel_Tank_Capacity: "1200L",
      Hold_Capacity: "6000kg",
      Engine_Capacity: "450HP",
      Fuel_Consumption: "45L/h",
      Fishing_Methods: "Trawling",
      Hull_Material: "Steel",
      Owner_Name: "user123",
      Owner_Address: "123 Harbor Rd, Boston, MA",
    },
    {
      _id: "vessel002",
      Name: "Sea Breeze",
      Flag: "Panama",
      IMO: "IMO7654321",
      IMULA_Number: "IMULA002",
      Call_Sign: "PQR456",
      AIS_transponder_Class: "Class B",
      General_vessel_Type: "Fishing",
      Detailed_vessel_Type: "Longliner",
      Categories: "Commercial",
      Service_Status: "Inactive",
      Port_of_registry: "Miami",
      Year_Built: 2018,
      License_Category: "Category B",
      National: "Panama",
      Registered_Date: "2018-07-22T00:00:00.000Z",
      Breadth: 7.8,
      Height: 3.9,
      Fuel_Type: "Diesel",
      Engine_Type: "Outboard",
      Fuel_Tank_Capacity: "800L",
      Hold_Capacity: "4000kg",
      Engine_Capacity: "300HP",
      Fuel_Consumption: "30L/h",
      Fishing_Methods: "Longlining",
      Hull_Material: "Fiberglass",
      Owner_Name: "user123",
      Owner_Address: "456 Coastal Ave, Miami, FL",
    },
    {
      _id: "vessel003",
      Name: "Blue Wave",
      Flag: "Canada",
      IMO: "IMO9876543",
      IMULA_Number: "IMULA003",
      Call_Sign: "LMN789",
      AIS_transponder_Class: "Class A",
      General_vessel_Type: "Fishing",
      Detailed_vessel_Type: "Purse Seiner",
      Categories: "Commercial",
      Service_Status: "Maintenance",
      Port_of_registry: "Vancouver",
      Year_Built: 2012,
      License_Category: "Category C",
      National: "Canada",
      Registered_Date: "2012-11-05T00:00:00.000Z",
      Breadth: 9.2,
      Height: 4.8,
      Fuel_Type: "Gasoline",
      Engine_Type: "Inboard",
      Fuel_Tank_Capacity: "1500L",
      Hold_Capacity: "8000kg",
      Engine_Capacity: "600HP",
      Fuel_Consumption: "60L/h",
      Fishing_Methods: "Purse Seining",
      Hull_Material: "Aluminum",
      Owner_Name: "user123",
      Owner_Address: "789 Seaside Dr, Vancouver, BC",
    },
  ];
  // Access user from context
  const { user } = useContext(AuthContext);
  const [userId, setUserId] = useState(null);
  const [allVessels, setAllVessels] = useState([]);
  const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false);
  const [selectedVessel, setSelectedVessel] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    _id: "",
    Name: "",
    Flag: "",
    IMO: "",
    IMULA_Number: "",
    Call_Sign: "",
    AIS_transponder_Class: "",
    General_vessel_Type: "",
    Detailed_vessel_Type: "",
    Categories: "",
    Service_Status: "",
    Port_of_registry: "",
    Year_Built: "",
    License_Category: "",
    National: "",
    Registered_Date: "",
    Breadth: "",
    Height: "",
    Fuel_Type: "",
    Engine_Type: "",
    Fuel_Tank_Capacity: "",
    Hold_Capacity: "",
    Engine_Capacity: "",
    Fuel_Consumption: "",
    Fishing_Methods: "",
    Hull_Material: "",
    Owner_Name: "", // Will be set to userId
    Owner_Address: "",
  });
  const [editFormData, setEditFormData] = useState({ ...formData });
  const [formErrors, setFormErrors] = useState({});
  const [editFormErrors, setEditFormErrors] = useState({});

  // Set userId when user is available
  useEffect(() => {
    console.log("user", user);
    if (!user) return;
    setUserId(user.uid);
  }, [user]);

  // Fetch vessels using getVesselsByOwner
  useEffect(() => {
    const fetchVessels = async () => {
      if (!userId) return;
      try {
        const response = await getVesselsByOwner(userId);
        console.log("response data", response.data);

        const vessels = response.data || [];
        setAllVessels(vessels);
      } catch (error) {
        console.error("Error fetching vessels:", error);
      }
    };

    fetchVessels();
  }, [userId]);

  useEffect(() => {
    const fetchVessel = async () => {
      try {
        const response = await getVessel(vessel);
        console.log("response data", response.data);

        const vessel1 = response.data || [];
        setImageLarge(vessel1.Image_Large);
        setImageSmall1(vessel1.Image_Small1);
        setImageSmall2(vessel1.Image_Small2);
        setImageSmall3(vessel1.Image_Small3);
        setImageSmall4(vessel1.Image_Small4);
      } catch (error) {
        console.error("Error fetching vessels:", error);
      }
    };

    fetchVessel();
  });

  const refreshComponent = async () => {
    const response = await getVesselsByOwner(userId);
    setAllVessels(response.data || []);

    const response1 = await getVessel(vessel);
    const vessel1 = response1.data || [];
    setImageLarge(vessel1.Image_Large);
    setImageSmall1(vessel1.Image_Small1);
    setImageSmall2(vessel1.Image_Small2);
    setImageSmall3(vessel1.Image_Small3);
    setImageSmall4(vessel1.Image_Small4);
    setKey((prev) => prev + 1);
  };

  // Toggle off-canvas
  const toggleOffcanvas = (vessel) => {
    setSelectedVessel(vessel);
    setIsOffcanvasOpen(true);
  };

  // Toggle add modal
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    if (isModalOpen) {
      setFormData({
        _id: "",
        Name: "",
        Flag: "",
        IMO: "",
        IMULA_Number: "",
        Call_Sign: "",
        AIS_transponder_Class: "",
        General_vessel_Type: "",
        Detailed_vessel_Type: "",
        Categories: "",
        Service_Status: "",
        Port_of_registry: "",
        Year_Built: "",
        License_Category: "",
        National: "",
        Registered_Date: "",
        Breadth: "",
        Height: "",
        Fuel_Type: "",
        Engine_Type: "",
        Fuel_Tank_Capacity: "",
        Hold_Capacity: "",
        Engine_Capacity: "",
        Fuel_Consumption: "",
        Fishing_Methods: "",
        Hull_Material: "",
        Owner_Name: "",
        Owner_Address: "",
      });
      setFormErrors({});
    }
  };

  // Toggle edit modal
  const toggleEditModal = (vessel) => {
    setIsEditModalOpen(!isEditModalOpen);
    if (isEditModalOpen) {
      setEditFormErrors({});
    } else {
      setEditFormData({
        _id: vessel._id,
        Name: vessel.Name || "",
        Flag: vessel.Flag || "",
        IMO: vessel.IMO || "",
        IMULA_Number: vessel.IMULA_Number || "",
        Call_Sign: vessel.Call_Sign || "",
        AIS_transponder_Class: vessel.AIS_transponder_Class || "",
        General_vessel_Type: vessel.General_vessel_Type || "",
        Detailed_vessel_Type: vessel.Detailed_vessel_Type || "",
        Categories: vessel.Categories || "",
        Service_Status: vessel.Service_Status || "",
        Port_of_registry: vessel.Port_of_registry || "",
        Year_Built: vessel.Year_Built || "",
        License_Category: vessel.License_Category || "",
        National: vessel.National || "",
        Registered_Date: vessel.Registered_Date
          ? new Date(vessel.Registered_Date).toISOString().split("T")[0]
          : "",
        Breadth: vessel.Breadth || "",
        Height: vessel.Height || "",
        Fuel_Type: vessel.Fuel_Type || "",
        Engine_Type: vessel.Engine_Type || "",
        Fuel_Tank_Capacity: vessel.Fuel_Tank_Capacity || "",
        Hold_Capacity: vessel.Hold_Capacity || "",
        Engine_Capacity: vessel.Engine_Capacity || "",
        Fuel_Consumption: vessel.Fuel_Consumption || "",
        Fishing_Methods: vessel.Fishing_Methods || "",
        Hull_Material: vessel.Hull_Material || "",
        Owner_Name: vessel.Owner_Name || "",
        Owner_Address: vessel.Owner_Address || "",
      });
    }
  };

  // Handle add form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setFormErrors({ ...formErrors, [name]: "" });
  };

  // Handle edit form input changes
  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditFormData({ ...editFormData, [name]: value });
    setEditFormErrors({ ...editFormErrors, [name]: "" });
  };

  // Validate form data
  const validateForm = () => {
    const errors = {};
    const requiredFields = [
      "Name",
      "Flag",
      "IMO",
      "General_vessel_Type",
      "Service_Status",
      "Port_of_registry",
      "Year_Built",
      "National",
      "Registered_Date",
      "Breadth",
      "Height",
      "Fuel_Type",
      "Engine_Type",
      "Owner_Name",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        errors[field] = `${field.replace(/_/g, " ")} is required`;
      }
    });

    if (formData.Year_Built && isNaN(formData.Year_Built)) {
      errors.Year_Built = "Year Built must be a number";
    }
    if (formData.Breadth && isNaN(formData.Breadth)) {
      errors.Breadth = "Breadth must be a number";
    }
    if (formData.Height && isNaN(formData.Height)) {
      errors.Height = "Height must be a number";
    }
    if (
      formData.Registered_Date &&
      isNaN(Date.parse(formData.Registered_Date))
    ) {
      errors.Registered_Date = "Invalid date format (use YYYY-MM-DD)";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleCheckboxChange = async (id, vesselNumber, newValue) => {
    // 1. Optimistic update
    setAllVessels((prev) =>
      prev.map((row) => (row._id === id ? { ...row, show: newValue } : row))
    );

    // 2. Send update to backend
    try {
      await fetch(
        `https://api.starmarketapi.online/vessel_details/api/vessels/${id}/show`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ show: newValue }),
        }
      );

      await fetch(
        `https://api.starmarketapi.online/vessel_service1/vessel/v1/vessels/show/${newValue}/${vesselNumber}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ show: newValue }),
        }
      );
    } catch (err) {
      console.error("Failed to update:", err);
      // Optional: revert state on error
      setAllVessels((prev) =>
        prev.map((row) => (row._id === id ? { ...row, show: !newValue } : row))
      );
    }
  };

  // Validate edit form data
  const validateEditForm = () => {
    const errors = {};
    const requiredFields = [
      "Name",
      "Flag",
      "IMO",
      "General_vessel_Type",
      "Service_Status",
      "Port_of_registry",
      "Year_Built",
      "National",
      "Registered_Date",
      "Breadth",
      "Height",
      "Fuel_Type",
      "Engine_Type",
      "Owner_Name",
    ];

    requiredFields.forEach((field) => {
      if (!editFormData[field]) {
        errors[field] = `${field.replace(/_/g, " ")} is required`;
      }
    });

    if (editFormData.Year_Built && isNaN(editFormData.Year_Built)) {
      errors.Year_Built = "Year Built must be a number";
    }
    if (editFormData.Breadth && isNaN(editFormData.Breadth)) {
      errors.Breadth = "Breadth must be a number";
    }
    if (editFormData.Height && isNaN(editFormData.Height)) {
      errors.Height = "Height must be a number";
    }
    if (
      editFormData.Registered_Date &&
      isNaN(Date.parse(editFormData.Registered_Date))
    ) {
      errors.Registered_Date = "Invalid date format (use YYYY-MM-DD)";
    }

    setEditFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Handle add form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const vesselData = { ...formData, Owner_Name: userId };
      await createVessel(vesselData);
      toggleModal();
      const response = await getVesselsByOwner(userId);
      setAllVessels(response.data.data || []);
    } catch (error) {
      console.error("Error creating vessel:", error);
      setFormErrors({ submit: "Failed to create vessel. Please try again." });
    }
  };

  const onImageUpload = (url) => {
    console.log("Image uploaded to:", url);
    setUploadedImageUrl(url);
  };

  const onImageUpload1 = (url) => {
    console.log("Image uploaded to:", url);
    setUploadedImageUrl(url);
  };

  // Handle edit form submission
  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (!validateEditForm()) return;

    try {
      const vesselData = { ...editFormData, id: userId };
      await createVessel(vesselData); // Use updateVessel if separate API exists
      toggleEditModal(null);
      const response = await getVesselsByOwner(userId);
      console.log("response data", response);
      setAllVessels(response.data.data || []);
    } catch (error) {
      console.error("Error updating vessel:", error);
      setEditFormErrors({
        submit: "Failed to update vessel. Please try again.",
      });
    }
  };

  const customStyles = {
    table: {
      style: {
        tableLayout: "auto", // Let content define width
      },
    },
    headCells: {
      style: {
        whiteSpace: "normal",
        overflow: "visible",
        textOverflow: "unset",
        wordBreak: "break-word",
        whiteSpace: "nowrap",
        maxWidth: "150px",
        paddingLeft: "10px",
        paddingRight: "10px",
      },
    },
    cells: {
      style: {
        paddingLeft: "10px",
        paddingRight: "10px",
      },
    },
  };

  // DataTable columns
  const columns = [
    {
      name: "Vessel Image",
      selector: (row) =>
        (
          <img
            key={key}
            src={row.Vessel_Thumb}
            style={{ width: "90%", borderRadius: "20px", margin: "10px" }}
          />
        ) || "N/A",
    },
    {
      name: "Vessel Name",
      selector: (row) => row.Name || "N/A",
      sortable: true,
    },
    {
      name: "IMULA Number",
      selector: (row) => row.IMULA_Number || "N/A",
      sortable: true,
    },
    {
      name: "Port of Registry",
      selector: (row) => row.Port_of_registry || "N/A",
      sortable: true,
    },
    {
      name: "Year",
      selector: (row) => row.Year_Built || "N/A",
      sortable: true,
    },
    {
      name: "Registered Date",
      selector: (row) =>
        row.Registered_Date
          ? new Date(row.Registered_Date).toLocaleDateString()
          : "N/A",
      sortable: true,
    },
    {
      name: "Owner Address",
      selector: (row) => row.Owner_Address || "N/A",
    },
    {
      name: "Show on Map",
      cell: (row) => (
        <input
          type="checkbox"
          checked={!!row.show}
          onChange={(e) =>
            handleCheckboxChange(row._id, row.IMULA_Number, e.target.checked)
          }
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: "Actions",
      width: "200px", // Adjust width as needed
      cell: (row) => (
        <div>
          <Button
            color="danger"
            size="sm"
            onClick={() => {
              setVessel(row.IMULA_Number);
              setIsOpen(true);
            }}
            className="pe-1 me-1"
            title="Add Images (Bulk)"
          >
            <FaCamera className="me-1" />
          </Button>
          <Button
            color="primary"
            size="sm"
            onClick={() => setVesselModalOpen(row.IMULA_Number)}
            className="pe-1 me-1"
            title="Add Image"
          >
            <FaCamera className="me-1" />
          </Button>
          <Button
            color="primary"
            size="sm"
            onClick={() => toggleOffcanvas(row)}
            className="pe-1 me-1"
            title="View Vessel Details"
          >
            <FaEye className="me-1" />
          </Button>
          {/* <Button
            color="warning"
            size="sm"
            onClick={() => toggleEditModal(row)}
            className="pe-1 me-1"
          >
            <FaEdit className="me-1" />
          </Button> */}
          <Button
            color="success"
            size="sm"
            onClick={() => toggleCrewModal(row)}
            className="pe-1 me-1"
            title="Add Crew Members"
          >
            <FaUserPlus className="me-1" />
          </Button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.5 }}
      >
        <div style={{ minHeight: '100%' }}>
          <Container fluid>
            <div style={{ overflowX: 'auto' }}>
              <Card style={{ backgroundColor: '#fff' }}>
                <CardBody style={{ padding: '20px' }}>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h5>My Vessels</h5>
                    {/* <Button color="primary" onClick={toggleModal}>
                      Add Vessel
                    </Button> */}
                  </div>
                  <DataTable
                    columns={columns}
                    data={allVessels}
                    customStyles={customStyles}
                    pagination
                    noDataComponent="No Vessels available."
                    responsive
                    fixedHeader
                  />
                </CardBody>
              </Card>
            </div>
          </Container>
        </div>
      </motion.div>

      {/* Offcanvas for Vessel Details */}
      {selectedVessel && (
        <VesselDetailsOffcanvas
          isOpen={isOffcanvasOpen}
          toggle={() => setIsOffcanvasOpen(false)}
          selectedVessel={selectedVessel}
        />
      )}

      {/* Modal for Adding Vessel */}
      <Modal
        isOpen={isModalOpen}
        toggle={toggleModal}
        size="lg"
      >
        <ModalHeader toggle={toggleModal}>Add New Vessel</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            {/* Form Fields (same as before, omitted for brevity) */}
            <FormGroup>
              <Label for="Name">Vessel Name *</Label>
              <Input
                type="text"
                name="Name"
                id="Name"
                value={formData.Name}
                onChange={handleInputChange}
                invalid={!!formErrors.Name}
              />
              <FormFeedback>{formErrors.Name}</FormFeedback>
            </FormGroup>
            {/* Add other form fields as in the previous version */}
            <FormGroup>
              <Label for="Owner_Name">Owner Name *</Label>
              <Input
                type="text"
                name="Owner_Name"
                id="Owner_Name"
                value={userId || ''}
                disabled
                invalid={!!formErrors.Owner_Name}
              />
              <FormFeedback>{formErrors.Owner_Name}</FormFeedback>
            </FormGroup>
            {formErrors.submit && (
              <div className="text-danger mb-3">{formErrors.submit}</div>
            )}
            <ModalFooter>
              <Button
                color="secondary"
                onClick={toggleModal}
              >
                Cancel
              </Button>
              <Button
                color="primary"
                type="submit"
              >
                Add Vessel
              </Button>
            </ModalFooter>
          </Form>
        </ModalBody>
      </Modal>

      {/* Modal for Editing Vessel */}
      <Modal
        isOpen={isEditModalOpen}
        toggle={() => toggleEditModal(null)}
        size="lg"
      >
        <ModalHeader toggle={() => toggleEditModal(null)}>
          Edit Vessel
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleEditSubmit}>
            <FormGroup>
              <Label for="Name">Vessel Name *</Label>
              <Input
                type="text"
                name="Name"
                id="Name"
                value={editFormData.Name}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.Name}
              />
              <FormFeedback>{editFormErrors.Name}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="Flag">Flag *</Label>
              <Input
                type="text"
                name="Flag"
                id="Flag"
                value={editFormData.Flag}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.Flag}
              />
              <FormFeedback>{editFormErrors.Flag}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="IMO">IMO *</Label>
              <Input
                type="text"
                name="IMO"
                id="IMO"
                value={editFormData.IMO}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.IMO}
              />
              <FormFeedback>{editFormErrors.IMO}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="IMULA_Number">IMULA Number</Label>
              <Input
                type="text"
                name="IMULA_Number"
                id="IMULA_Number"
                value={editFormData.IMULA_Number}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.IMULA_Number}
              />
              <FormFeedback>{editFormErrors.IMULA_Number}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="Call_Sign">Call Sign</Label>
              <Input
                type="text"
                name="Call_Sign"
                id="Call_Sign"
                value={editFormData.Call_Sign}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.Call_Sign}
              />
              <FormFeedback>{editFormErrors.Call_Sign}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="AIS_transponder_Class">AIS Transponder Class</Label>
              <Input
                type="text"
                name="AIS_transponder_Class"
                id="AIS_transponder_Class"
                value={editFormData.AIS_transponder_Class}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.AIS_transponder_Class}
              />
              <FormFeedback>
                {editFormErrors.AIS_transponder_Class}
              </FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="General_vessel_Type">General Vessel Type *</Label>
              <Input
                type="text"
                name="General_vessel_Type"
                id="General_vessel_Type"
                value={editFormData.General_vessel_Type}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.General_vessel_Type}
              />
              <FormFeedback>{editFormErrors.General_vessel_Type}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="Detailed_vessel_Type">Detailed Vessel Type</Label>
              <Input
                type="text"
                name="Detailed_vessel_Type"
                id="Detailed_vessel_Type"
                value={editFormData.Detailed_vessel_Type}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.Detailed_vessel_Type}
              />
              <FormFeedback>{editFormErrors.Detailed_vessel_Type}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="Categories">Categories</Label>
              <Input
                type="text"
                name="Categories"
                id="Categories"
                value={editFormData.Categories}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.Categories}
              />
              <FormFeedback>{editFormErrors.Categories}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="Service_Status">Service Status *</Label>
              <Input
                type="select"
                name="Service_Status"
                id="Service_Status"
                value={editFormData.Service_Status}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.Service_Status}
              >
                <option value="">Select Status</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
                <option value="Maintenance">Maintenance</option>
              </Input>
              <FormFeedback>{editFormErrors.Service_Status}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="Port_of_registry">Port of Registry *</Label>
              <Input
                type="text"
                name="Port_of_registry"
                id="Port_of_registry"
                value={editFormData.Port_of_registry}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.Port_of_registry}
              />
              <FormFeedback>{editFormErrors.Port_of_registry}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="Year_Built">Year Built *</Label>
              <Input
                type="number"
                name="Year_Built"
                id="Year_Built"
                value={editFormData.Year_Built}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.Year_Built}
              />
              <FormFeedback>{editFormErrors.Year_Built}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="License_Category">License Category</Label>
              <Input
                type="text"
                name="License_Category"
                id="License_Category"
                value={editFormData.License_Category}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.License_Category}
              />
              <FormFeedback>{editFormErrors.License_Category}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="National">National *</Label>
              <Input
                type="text"
                name="National"
                id="National"
                value={editFormData.National}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.National}
              />
              <FormFeedback>{editFormErrors.National}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="Registered_Date">Registered Date *</Label>
              <Input
                type="date"
                name="Registered_Date"
                id="Registered_Date"
                value={editFormData.Registered_Date}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.Registered_Date}
              />
              <FormFeedback>{editFormErrors.Registered_Date}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="Breadth">Breadth (m) *</Label>
              <Input
                type="number"
                name="Breadth"
                id="Breadth"
                value={editFormData.Breadth}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.Breadth}
                step="0.1"
              />
              <FormFeedback>{editFormErrors.Breadth}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="Height">Height (m) *</Label>
              <Input
                type="number"
                name="Height"
                id="Height"
                value={editFormData.Height}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.Height}
                step="0.1"
              />
              <FormFeedback>{editFormErrors.Height}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="Fuel_Type">Fuel Type *</Label>
              <Input
                type="text"
                name="Fuel_Type"
                id="Fuel_Type"
                value={editFormData.Fuel_Type}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.Fuel_Type}
              />
              <FormFeedback>{editFormErrors.Fuel_Type}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="Engine_Type">Engine Type *</Label>
              <Input
                type="text"
                name="Engine_Type"
                id="Engine_Type"
                value={editFormData.Engine_Type}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.Engine_Type}
              />
              <FormFeedback>{editFormErrors.Engine_Type}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="Fuel_Tank_Capacity">Fuel Tank Capacity</Label>
              <Input
                type="text"
                name="Fuel_Tank_Capacity"
                id="Fuel_Tank_Capacity"
                value={editFormData.Fuel_Tank_Capacity}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.Fuel_Tank_Capacity}
              />
              <FormFeedback>{editFormErrors.Fuel_Tank_Capacity}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="Hold_Capacity">Hold Capacity</Label>
              <Input
                type="text"
                name="Hold_Capacity"
                id="Hold_Capacity"
                value={editFormData.Hold_Capacity}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.Hold_Capacity}
              />
              <FormFeedback>{editFormErrors.Hold_Capacity}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="Engine_Capacity">Engine Capacity</Label>
              <Input
                type="text"
                name="Engine_Capacity"
                id="Engine_Capacity"
                value={editFormData.Engine_Capacity}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.Engine_Capacity}
              />
              <FormFeedback>{editFormErrors.Engine_Capacity}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="Fuel_Consumption">Fuel Consumption</Label>
              <Input
                type="text"
                name="Fuel_Consumption"
                id="Fuel_Consumption"
                value={editFormData.Fuel_Consumption}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.Fuel_Consumption}
              />
              <FormFeedback>{editFormErrors.Fuel_Consumption}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="Fishing_Methods">Fishing Methods</Label>
              <Input
                type="text"
                name="Fishing_Methods"
                id="Fishing_Methods"
                value={editFormData.Fishing_Methods}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.Fishing_Methods}
              />
              <FormFeedback>{editFormErrors.Fishing_Methods}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="Hull_Material">Hull Material</Label>
              <Input
                type="text"
                name="Hull_Material"
                id="Hull_Material"
                value={editFormData.Hull_Material}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.Hull_Material}
              />
              <FormFeedback>{editFormErrors.Hull_Material}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="Owner_Name">Owner Name * edit</Label>
              <Input
                type="text"
                name="Owner_Name"
                id="Owner_Name"
                onChange={handleEditInputChange}
                value={editFormData.Owner_Name}
                invalid={!!editFormErrors.Owner_Name}
              />
              <FormFeedback>{editFormErrors.Owner_Name}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="Owner_Address">Owner Address</Label>
              <Input
                type="text"
                name="Owner_Address"
                id="Owner_Address"
                value={editFormData.Owner_Address}
                onChange={handleEditInputChange}
                invalid={!!editFormErrors.Owner_Address}
              />
              <FormFeedback>{editFormErrors.Owner_Address}</FormFeedback>
            </FormGroup>

            {editFormErrors.submit && (
              <div className="text-danger mb-3">{editFormErrors.submit}</div>
            )}

            <ModalFooter>
              <Button
                color="secondary"
                onClick={() => toggleEditModal(null)}
              >
                Cancel
              </Button>
              <Button
                color="primary"
                type="submit"
              >
                Save Changes
              </Button>
            </ModalFooter>
          </Form>
        </ModalBody>
      </Modal>
      {selectedVesselForCrew && (
        <CrewMember
          isOpen={isCrewModalOpen}
          toggle={() => setIsCrewModalOpen(false)}
          vesselId={selectedVesselForCrew.IMULA_Number}
          vesselName={selectedVesselForCrew.Name}
          onCrewAdded={handleCrewAdded}
        />
      )}
      <ImageCropModal1
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onUpload={onImageUpload}
        IMULA_Number={vessel}
        refreshComponent={refreshComponent}
      />

      <ImageCropModal3
        isOpen={modalOpen1}
        onClose={() => setModalOpen1(false)}
        onUpload={onImageUpload1}
        IMULA_Number={vessel} // Pass the IMULA_Number to the modal
        fileNumber={fileNumber} // Pass the file number to the modal
        refreshComponent={refreshComponent}
      />
      <BoatGalleryModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        images={images}
        onCameraClick={(fileno) => {
          console.log(fileno);
          setFileNumber(fileno);
          setIsOpen(false);
          setModalOpen1(true);
        }}
      />
    </>
  );
};

export default Vessels;
